import React from "react";
import {
  Route,
  Switch,
  useRouteMatch,
  NavLink as Links,
} from "react-router-dom";
import ViewEmployee from "./ViewEmployee";
import NewEmployee from "./NewEmployee";
import EditEmployee from "./EditEmployee";
import Error404 from "../../../Components/Error404";
export default function Employee(props) {
  const { url } = useRouteMatch();
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>Employee Management</strong>
              <small className="subtitle">
                Here you can edit,delete,view Employees.
              </small>
            </h2>
          </div>
          <div className="right gap-items-2">
            {props.location.pathname !== url ? (
              <Links
                className="btn btn-mute btn-square btn-round"
                activeClassName="active"
                to={url}
              >
                <span className="material-icons-outlined">arrow_back</span>
              </Links>
            ) : (
              <Links
                className="btn btn-primary  btn-float btn-round"
                activeClassName="active"
                to={`${url}/Add`}
              >
                <span className="material-icons-outlined">add</span>
              </Links>
            )}
          </div>
        </div>
      </header>
      <Switch>
        <Route path={url} exact component={ViewEmployee} />
        <Route path={`${url}/Edit/:id`} exact component={EditEmployee} />
        <Route path={`${url}/Add`} exact component={NewEmployee} />
        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </div>
  );
}
